import React, { Component } from 'react';
import axios from 'axios';
import Lightbox from 'react-image-lightbox';

import { TabNavigation } from '../reusable/tab-navigation';
import {ROOT_URL, TOKEN} from '../../config';

export default class Gallerie extends Component {
  state = {
    data: '',
    loading: true,
    lightbox: [],
    photoIndex: 0,
    isOpen: false
  }

  componentDidMount() {
    axios.get(`${ROOT_URL}/cockpit-master/api/collections/get/gallerie?token=${TOKEN}`, {
    method: 'GET',
    authorization: 'basic',
    headers: { 'Content-Type': 'application/json', /*'Access-Control-Allow-Origin': '*'*/ },
  })
    .then(res => this.setState({
      data: res.data.entries,
      loading: false
    }))
  }

  renderImages = (items) => {
    var imageArray = this.state.lightbox = [];
    return (
      items.gallerie.map((image, i) => {
        imageArray.push(ROOT_URL + image.path);
        return (
          <div key={i} className=" item nop">
            <img
              alt-text=""
              className="img-gallerie"
              src={ROOT_URL + image.path}
              data-image={i}
              onClick={() => this.setState({ isOpen: true, photoIndex: i })}
             />
          </div>
        );
      })
    );
  }

  renderHelper = () => {
    const items = this.state.data;
    return (
      items.map((items, i) => {
        if('/galerie/' + items.titel === this.props.location.pathname) {
          return (
            <div key={i} className=" masonry">
              {this.renderImages(items)}
            </div>
          );
        }
      })
    );
  }

  render() {
    const { photoIndex, isOpen, lightbox } = this.state;
    if(this.state.loading === true) {
      return(
        <div className="container fullScreen">
          ...Loading
        </div>
      );
    } else {
      return(
        <div className="container fullScreen nop">

          {isOpen && (
          <Lightbox
            mainSrc={lightbox[photoIndex]}
            nextSrc={lightbox[(photoIndex + 1) % lightbox.length]}
            prevSrc={lightbox[(photoIndex + lightbox.length - 1) % lightbox.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + lightbox.length - 1) % lightbox.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % lightbox.length,
              })
            }
          />
        )}
          <div className="container">
            <h1 className="effect container">Galerie</h1>
          </div>
          <TabNavigation />
          <div className="container">
            <div className="nop row col-12 card">{this.renderHelper()}</div>
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/gallerie.js